import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAllyShopDeptPromo = loadable(() => import(/* webpackChunkName: "content/registry/ally-shop-dept-promo" */ './AllyShopDeptPromo'), 'AllyShopDeptPromo');
